import React from "react";
import type { Meal } from "../meal";
import { ImageImporter } from "../ImageImporter";
import "./menuItem.scss";

type Props = {
  meal: Meal;
};

const MenuItem = ({ meal }: Props) => {
  const mealImage = ImageImporter[meal.image];

  return (
    <article className="delivery-menu-card">
      <div className="delivery-menu-card__media">
        <img src={mealImage} alt="" loading="lazy" />
      </div>
      <div className="delivery-menu-card__body">
        <h3 className="delivery-menu-card__name">{meal.nameRus}</h3>
        <p className="delivery-menu-card__meta">
          Вес готового блюда · {meal.weight}
        </p>
        <p className="delivery-menu-card__price">
          {meal.price.toLocaleString("ru-RU")} ₽
        </p>
      </div>
    </article>
  );
};

export default MenuItem;
